/** Team page: members, invites, member dialogs. */
export const team = {
  title: "Team",
  intro: "Everyone with access to {org}, across all its brands. Every member uses two-step verification.",
  inviteMember: "Invite member",
  newRole: "New role",
  viewsLabel: "Team views",
  tabMembers: "Members",
  tabRoles: "Roles",

  // Brand scope
  allBrands: "All brands",
  unknownBrand: "Unknown brand",

  // Member table
  membersLabel: "Members",
  membersCaption: "Team members",
  colMember: "Member",
  colRole: "Role",
  colBrands: "Brands",
  colLastLogin: "Last login",
  colActions: "Actions",
  ownIpList: "Own IP list",
  personalIpList: "Personal console IP list: {ips}",
  personalIpAny: "Personal console IP list: any network",
  no2fa: "Hasn't finished 2FA setup",
  ipList: "IP list",
  disable: "Disable",

  // Invites table
  pendingInvites: "Pending invites",
  colEmail: "Email",
  colSent: "Sent",
  colExpires: "Expires",
  cancelInvite: "Cancel invite",
  noInvitesTitle: "No pending invites",
  noInvitesBody: "Invites you send show up here until they're accepted or expire (72 hours).",

  // After disabling someone
  disabledTitle: "{name} was disabled",
  dismiss: "Dismiss",
  disabledKeys: {
    one: "They created {n} active API key. Keys keep working; rotate them in <a>Developers</a> if needed.",
    other: "They created {n} active API keys. Keys keep working; rotate them in <a>Developers</a> if needed.",
  },

  // Toasts
  roleChanged: "{name} is now {role}",
  ipSaved: "Console IP list saved",
  inviteCancelled: "Invite cancelled",

  // Disable / cancel dialogs
  disableTitle: "Disable {name}?",
  disableEnrolling: "They haven't finished setting up two-step verification. Disabling stops them from finishing it.",
  disableActive: "They are logged out of {org} right away, and invites they sent are cancelled. Their history stays in the activity log.",
  disableMember: "Disable member",
  cancelInviteTitle: "Cancel this invite?",
  cancelInviteBody: "The link sent to <b>{email}</b> stops working.",

  // Shared form bits
  role: "Role",
  loadingOption: "Loading…",
  customRole: "{name} (custom)",
  brands: "Brands",
  allBrandsFuture: "All brands (including future ones)",
  allBrandsFutureHint: "New brands in this organization are included automatically.",
  codeRequired: "Enter the 6-digit code from your authenticator app.",
  codeFailed: "That code didn't work. Wait for the next code and try again.",
  pickBrand: "Pick at least one brand, or all brands.",

  // Invite dialog
  invalidEmail: "Enter a valid email address.",
  inviteReady: "Invite link ready",
  inviteTitle: "Invite a team member",
  inviteDesc: "They'll set a password and turn on two-step verification. People who already have an iCryptoNow login just log in and join.",
  inviteCreated: "Invite created for {email}",
  inviteCreatedBody: "We don't email it. Send the link yourself, privately (for example a direct message). It works once and expires in 72 hours.",
  inviteEmailed: "Invitation e-mailed to {email}",
  inviteEmailedBody: "They'll find the link in their inbox (ask them to check spam too). You can also send the link yourself; it works once and expires in 72 hours.",
  inviteNotEmailed: "Invite created for {email}, but the e-mail wasn't sent",
  inviteNotEmailedBody: "Send the link yourself, privately (for example a direct message). It works once and expires in 72 hours.",
  inviteLink: "Invite link",
  copyLink: "Copy link",
  email: "Email",
  createInviteLink: "Create invite link",

  // Edit member dialog
  editTitle: "Edit {name}",
  editDesc: "Changes apply at once. Sessions on a brand that leaves their scope end.",
  saveChanges: "Save changes",

  // Personal console IP list dialog
  ipTitle: "Console IP list for {name}",
  ipDesc: "Where this person may use the console from. It replaces the organization's list for them.",
  networks: "Networks",
  useOrgList: "Use the organization's list",
  useOrgListHint: "Set in Settings. Recommended for most people.",
  personalList: "Personal list",
  personalListHint: "Only these networks, for example a person working from home.",
  ipAddresses: "IP addresses or ranges",
  ipHint: "One per line (IPv4/IPv6 or CIDR). Empty = any network for this person.",
  ownListWarn: "This is your own list. Saving a list that doesn't include your current network is refused.",
};
